var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationSuccess(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8229_724",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8229_724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.607 19.1791L20.212 12.5741L19.1767 11.5388L13.607 17.1086L10.807 14.3086L9.77169 15.3439L13.607 19.1791ZM15.003 24.3333C13.7121 24.3333 12.4987 24.0884 11.3628 23.5985C10.2269 23.1085 9.23887 22.4437 8.39871 21.6038C7.55854 20.764 6.89334 19.7764 6.40309 18.641C5.91301 17.5056 5.66797 16.2925 5.66797 15.0017C5.66797 13.7108 5.91293 12.4974 6.40285 11.3615C6.89276 10.2256 7.55764 9.23756 8.39748 8.3974C9.23731 7.55724 10.2249 6.89203 11.3603 6.40179C12.4957 5.9117 13.7088 5.66666 14.9996 5.66666C16.2905 5.66666 17.5039 5.91162 18.6398 6.40154C19.7757 6.89146 20.7637 7.55634 21.6039 8.39617C22.4441 9.23601 23.1093 10.2236 23.5995 11.359C24.0896 12.4944 24.3346 13.7075 24.3346 14.9983C24.3346 16.2892 24.0897 17.5026 23.5998 18.6385C23.1098 19.7744 22.445 20.7624 21.6051 21.6026C20.7653 22.4428 19.7777 23.108 18.6423 23.5982C17.5069 24.0883 16.2938 24.3333 15.003 24.3333ZM15.0013 22.8596C17.1955 22.8596 19.0539 22.0982 20.5767 20.5754C22.0995 19.0526 22.861 17.1941 22.861 15C22.861 12.8058 22.0995 10.9474 20.5767 9.42456C19.0539 7.90175 17.1955 7.14035 15.0013 7.14035C12.8071 7.14035 10.9487 7.90175 9.42586 9.42456C7.90306 10.9474 7.14165 12.8058 7.14165 15C7.14165 17.1941 7.90306 19.0526 9.42586 20.5754C10.9487 22.0982 12.8071 22.8596 15.0013 22.8596Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSuccess);
export default __webpack_public_path__ + "static/media/notificationSuccess.446ec4cd617cc9a01d482884d1a9775f.svg";
export { ForwardRef as ReactComponent };